import React from "react"
import StatusIndicator from "../StatusIndicator"
import PropTypes from "prop-types"
const statusToColorMap = {
  "At Risk": "warning",
  Late: "error",
  "On Time": "success",
  "Not at Risk": "success",
}
const RiskStatusIndicator = ({ status = "On Time", size = "med" }) => {
  return (
    <StatusIndicator
      status={statusToColorMap[status]}
      size={size}
    />
  )
}

export default RiskStatusIndicator

RiskStatusIndicator.propTypes = {
  /**
   * The size of the risk status indicator.
   */
  size: PropTypes.oneOf(["med", "sm"]),
  status: PropTypes.oneOf(["At Risk", "Late", "On Time", "Not at Risk"]),
}
